import Lottie from 'lottie-web';

/**
 * Class definition for `wp-animated-icon` element
 *
 * @class WPAnimatedIcon
 * @extends {HTMLElement}
 */
class WPAnimatedIcon extends HTMLElement {
  constructor(self) {
    self = super(self);
    return self;
  }

  get icon() {
    return this.getAttribute('icon');
  }

  get trigger() {
    return this.hasAttribute('trigger')
      ? this.getAttribute('trigger')
      : 'waypoint';
  }

  get loop() {
    return this.hasAttribute('loop');
  }

  /**
   * Tag name of element
   *
   * @readonly
   * @static
   */
  static get is() {
    return 'wp-animated-icon';
  }

  connectedCallback() {
    if (!this.icon) {
      console.log('Animated icon missing icon');
      return;
    }

    // Add scroll observer
    this.setAttribute('data-sal', '');

    // Setup lottie animation
    this.animation = Lottie.loadAnimation({
      container: this,
      renderer: 'svg',
      loop: this.loop,
      autoplay: false,
      path: `/wp-content/themes/genv/static/icons/${this.icon}.json`,
    });

    // Play animation on scroll intersection
    if (this.trigger === 'waypoint') {
      this.addEventListener('sal:in', ({ detail }) => {
        this.animation.play();
      });
    }
  }
}

customElements.define(WPAnimatedIcon.is, WPAnimatedIcon);
